{
  "settings": "Nastavení",
  "yourDigitalAssistant": "Tvůj digitální asistent",
  "getStarted": "Začínáme",
  "login": "Přihlásit se",
  "loggingIn": "Přihlašování ...",
  "darkMode": "Tmavý režim",
  "clearHistory": "Vymazat historii",
  "historyCleared": "Historie vymazána",
  "changeLanguage": "Jazyk",
  "termsAndConditions": "Podmínky užití",
  "messagePlaceholder": "Zde napiš zprávu ...",
  "messagePlaceholderDisabled": "Psaní deaktivováno ...",
  "feedbackTitle": "Hodnocení konverzace",
  "feedbackPlaceholder": "Řekni nám víc (nepovinné)",
  "feedbackSend": "Poslat",
  "feedbackClose": "Zavřít",
  "sessionExpired": "Dlouho jsme od tebe neslyšeli zpět, chat byl ukončen.",
  "startNewSession": "Začít znovu",
  "apiError": "Ups! Něco se pokazilo. Pracujeme na co nejdřívější nápravě.",
  "apiErrorOffline": "Nejste připojeni k internetu.",
  "tryAgain": "Zkusit znovu",
  "startOver": "Začít znovu",
  "chatEnded": "Chat byl ukončen.",
  "chatEndedThankYou": "Děkujeme za chat s Vámi!",
  "closeChat": "Zavřít",
  "startNewChat": "Začít znovu",
  "humanTakeoverStarted": "Nyní vás přepojujeme do zákaznického servisu ...",
  "humanTakeoverQueued": "Čekáme na spojení s agentem",
  "humanTakeoverAnAgent": "Agent",
  "humanTakeoverAgentEntered": "vstoupil do konverzace",
  "humanTakeoverAgentLogout": "opustil konverzaci",
  "humanTakeoverTransfer": "Probíhá převod k novému agentovi",
  "humanTakeoverEnded": "Nyní konverzujete s digitálním asistentem",
  "version": "Verze",
  "formIntroText": "Vyplňte prosím následující formulář a začněte s námi chatovat.",
  "formFirstName": "Jméno",
  "formLastName": "Příjmení",
  "formName": "Name",
  "formEmail": "E-mail",
  "formWrongEmail": "Uveďte prosím platnou e-mailovou adresu.",
  "formPhone": "Telefon",
  "formShipmentId": "ID zásilky",
  "formQuestion": "Vaše otázka",
  "formAccountNumber": "Číslo účtu (pro obchodní zákazníky)",
  "formAddress": "Adresa",
  "formPostcode": "PSČ",
  "formCity": "Město",
  "formCountry": "Země",
  "formSubmitButton": "Zahájit chat",
  "formEmptyFieldError": "Není dovoleno být prázdné.",
  "formPhoneNumberValidationError": "Není platné telefonní číslo.",
  "formInputIsBiggerThan50": "Musí mít nejvýše 50 znaků.",
  "formInputIsBiggerThan100": "Musí mít nejvýše 100 znaků.",
  "formInputIsBiggerThan2000": "Musí mít nejvýše 2 000 znaků.",
  "widgetEventOnline": "DA zpráva: Uživatel je zpět online.",
  "widgetEventHidden": "DA zpráva: Widget je skrytý.",
  "widgetEventVisible": "DA zpráva: Widget je viditelný.",
  "widgetEventVisibleMinimized": "DA zpráva: Widget je viditelný, ale minimalizovaný.",
  "widgetEventMinimized": "DA zpráva: Widget je minimalizován.",
  "widgetEventMaximized": "DA zpráva: Widget je maximalizován.",
  "widgetEventSessionExpired": "DA zpráva: Widget konverzace expirovala.",
  "widgetEventHangupHuman": "Zpráva DA: Uživatel ukončuje relaci převzetí člověka.",
  "widgetEventUserTyping": "DA zpráva: Uživatel píše.",
  "fileTooLarge": "Pokoušíte se připojit příliš velké soubory.",
  "tooManyDiles": "Pokoušíte se připojit příliš mnoho souborů.",
  "fileInvalidType": "Pokoušíte se připojit neplatné typy souborů.",
  "attachmentsDropHere": "Přetažením sem nahrajte nebo",
  "attachmentsBrowse": "Procházet soubory",
  "attachmentsExtenstionQuantity": "pdf nebo obrázky (až 10 souborů)",
  "attachmentsSize": "až 30 MB",
  "attachmentsFailedUploading": "Nahrávání se nezdařilo",
  "attachmentsUploading": "Nahrávám ...",
  "minimizeExpandText": "Chatujte s námi nyní!",
  "popupWidgetNotificationMessage": "Dostali jste novou zprávu!",
  "tabWidgetNotificationMessage": "Nová zpráva!",
  "datepickerSendButton": "Poslat"
}
